export default {
	'system.user.title': '用户信息',
	'system.user.user_id': '用户编号',
	'system.user.dept_name': '部门',
	'system.user.user_name': '用户账号',
	'system.user.nick_name': '用户昵称',
	'system.user.user_type': '用户类型',
	'system.user.email': '用户邮箱',
	'system.user.phonenumber': '手机号码',
	'system.user.sex': '用户性别',
	'system.user.avatar': '头像地址',
	'system.user.password': '密码',
	'system.user.status': '帐号状态',
	'system.user.del_flag': '删除标志',
	'system.user.login_ip': '最后登录IP',
	'system.user.login_date': '最后登录时间',
	'system.user.create_by': '创建者',
	'system.user.create_time': '创建时间',
	'system.user.update_by': '更新者',
	'system.user.update_time': '更新时间',
	'system.user.remark': '备注',
	'system.user.post': '岗位',
	'system.user.role': '角色',
	'system.user.auth.role': '分配角色',
	'system.user.reset.password': '密码重置',
	'system.user.modify_info': '编辑用户信息',
	'system.user.old_password': '旧密码',
	'system.user.new_password': '新密码',
	'system.user.confirm_password': '确认密码',
	'system.user.modify_avatar': '修改头像',
};
